import { render, staticRenderFns } from "./fund-list.vue?vue&type=template&id=dedba6cc&"
import script from "./fund-list.vue?vue&type=script&lang=js&"
export * from "./fund-list.vue?vue&type=script&lang=js&"
import style0 from "./fund-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fund-list.vue"
export default component.exports